<mat-card class="content-card">

  <h3>Marketing Dashboard</h3>

  <h4>Filters and Grouping</h4>

  <div fxLayout="row" style="">

    <div fxFlex="100">
      <form [formGroup]="orderStatsForm" (ngSubmit)="submit()">
        <mat-form-field>
          <mat-label>Start Date</mat-label>
          <input matInput [matDatepicker]="picker1" formControlName="startDate">
          <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
          <mat-datepicker #picker1></mat-datepicker>
        </mat-form-field>

        <mat-form-field>
          <mat-label>End Date</mat-label>
          <input matInput [matDatepicker]="picker2" formControlName="endDate">
          <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
          <mat-datepicker #picker2></mat-datepicker>
        </mat-form-field>

        <mat-form-field>
          <mat-label>Grouping</mat-label>
          <mat-select formControlName="grouping">
            <mat-option *ngFor="let group of [{key: 0, name: 'None'}, {key: 1, name: 'Country'}, {key: 3, name: 'City'}, {key: 4, name: 'Age'}, {key: 6, name: 'Platform'}, {key: 7, name: 'Order source'}, {key: 8, name: 'Brand'}]"
                        [value]="group.key">
              {{group.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field>
          <mat-label>Interval</mat-label>
          <mat-select formControlName="interval">
            <mat-option *ngFor="let interval of [{key: 1, name: 'Day'}, {key: 2, name: 'Week'}, {key: 3, name: 'Month'}, {key: 4, name: 'Quarter'}, {key: 5, name: 'Year'}]"
                        [value]="interval.key">
              {{interval.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <button [disabled]="isLoadingOrders || isLoadingLoads" style="margin-left: 10px;" mat-raised-button color="primary" type="submit">
          Submit
        </button>

        <button mat-raised-button [disabled]="isLoadingOrders || isLoadingLoads" style="margin-left: 10px; margin-right: 5px;" type="button"
                (click)="goToPreviousPeriod()">Previous
        </button>
        <button mat-raised-button [disabled]="isLoadingOrders || isLoadingLoads" type="button" (click)="goToNextPeriod()">Next</button>

      </form>
    </div>
  </div>

  <div fxLayout="row wrap" fxLayoutGap="8px" *ngIf="filters">

    <mat-form-field class="country-filter-field">
      <mat-select placeholder="Country filters" [(ngModel)]="selectedCountries" multiple>
        <mat-option *ngFor="let country of countries" [value]="country">{{country.name}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="brand-filter-field" *ngIf="!currentUserIsPartner()">
      <mat-select placeholder="Brand filters" [(ngModel)]="selectedCompanies" (ngModelChange)="companyChanged()"
                  multiple>
        <mat-option *ngFor="let company of companies" [value]="company">{{company.name}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="product-filter-field" *ngIf="!currentUserIsPartner()">
      <mat-select placeholder="Product filters" [(ngModel)]="selectedProducts" multiple>
        <mat-option *ngFor="let product of products" [value]="product">{{product.internalName}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="platform-filter-field">
      <mat-select placeholder="Platform filters" [(ngModel)]="selectedPlatform">
        <mat-option [value]="-1">All</mat-option>
        <mat-option [value]="0">Unknown</mat-option>
        <mat-option [value]="1">iOS</mat-option>
        <mat-option [value]="2">Android</mat-option>
      </mat-select>
    </mat-form-field>

  </div>


  <h4>Totals</h4>


  <div fxLayout="row" style="">
    <div fxFlex="100">


      <mat-progress-bar *ngIf="isLoadingTotals" mode="indeterminate"></mat-progress-bar>

      <div style="width: 100%; overflow-x: scroll;">

        <div style="display: inline-block; width: 200px; height: 80px; text-align: center; margin-right: 15px; border: 1px solid grey; border-radius: 20px; padding: 20px;">
          <div style="font-size: .9em;">Orders</div>
          <div *ngIf="totals" style="font-family: monospace; font-weight: bold; font-size: 2em;">{{totals.numberOfOrders | number: '1.0-0'}}</div>
        </div>

        <div style="display: inline-block; width: 200px; height: 80px; text-align: center; margin-right: 15px; border: 1px solid grey; border-radius: 20px; padding: 20px;">
          <div style="font-size: .9em;">Load volume</div>
          <div *ngIf="totals" style="font-family: monospace; font-weight: bold; font-size: 2em;">{{totals.loadVolume | number: '1.2-2'}}</div>
        </div>

        <div style="display: inline-block; width: 200px; height: 80px; text-align: center; margin-right: 15px; border: 1px solid grey; border-radius: 20px; padding: 20px;">
          <div style="font-size: .9em;">Loads</div>
          <div *ngIf="totals" style="font-family: monospace; font-weight: bold; font-size: 2em;">{{totals.numberOfLoads | number: '1.0-0'}}</div>
        </div>

        <div style="display: inline-block; width: 200px; height: 80px; text-align: center; margin-right: 15px; border: 1px solid grey; border-radius: 20px; padding: 20px;">
          <div style="font-size: .9em;">Loaded Cards</div>
          <div *ngIf="totals" style="font-family: monospace; font-weight: bold; font-size: 2em;">{{totals.numberLoadedCards | number: '1.0-0' }}</div>
        </div>


      </div>

    </div>

  </div>

  <h4>Orders</h4>


  <div fxLayout="row" style="">
    <div fxFlex="100">


      <mat-progress-bar *ngIf="isLoadingOrders" mode="indeterminate"></mat-progress-bar>

      <div style="width: 100%; overflow-x: scroll;">
        <ngx-charts-bar-vertical-stacked
          [view]="[900, 400]"
          [scheme]="colorScheme"
          [results]="chartOrdersData"
          [gradient]="gradient"
          [xAxis]="true"
          [yAxis]="true"
          [legend]="true"
          [showXAxisLabel]="true"
          [showYAxisLabel]="true"
          [xAxisLabel]="xAxisLabel"
          [yAxisLabel]="'Orders Count'">
        </ngx-charts-bar-vertical-stacked>


      </div>

    </div>

  </div>

  <button mat-raised-button (click)="toggleDisplayRowOrderValues()">Display raw values</button>



  <div *ngIf="displayRawOrdersValues">

    <h4>Raw Values - Orders</h4>

    <!-- Table with raw data -->
    <table mat-table [dataSource]="tableOrdersData" class="mat-elevation-z8">

      <!-- Date Column -->
      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef> Date</th>
        <td mat-cell *matCellDef="let element"> {{element.date}} </td>
      </ng-container>

      <!-- Age Group Columns -->
      <ng-container *ngFor="let column of displayedOrdersColumns" [matColumnDef]="column">
        <th mat-header-cell *matHeaderCellDef> {{column}} </th>
        <td mat-cell *matCellDef="let element"> {{element[column]}} </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedOrdersColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedOrdersColumns;"></tr>
    </table>
  </div>



  <!-- LOADS -->
  <h4>Card Loads</h4>

  <div fxLayout="row" style="">
    <div fxFlex="100">

      <mat-progress-bar *ngIf="isLoadingLoads" mode="indeterminate"></mat-progress-bar>

      <div style="width: 100%; overflow-x: scroll;">
        <ngx-charts-bar-vertical-stacked
          [view]="[900, 400]"
          [scheme]="colorScheme2"
          [results]="chartLoadsData"
          [gradient]="gradient"
          [xAxis]="true"
          [yAxis]="true"
          [legend]="true"
          [showXAxisLabel]="true"
          [showYAxisLabel]="true"
          [xAxisLabel]="xAxisLabel"
          [yAxisLabel]="'Load Count'">
        </ngx-charts-bar-vertical-stacked>

        <div style="width: 100%; overflow-x: scroll;">
          <ngx-charts-bar-vertical-stacked
            [view]="[900, 400]"
            [scheme]="colorScheme3"
            [results]="chartLoadsVolumeData"
            [gradient]="gradient"
            [xAxis]="true"
            [yAxis]="true"
            [legend]="true"
            [showXAxisLabel]="true"
            [showYAxisLabel]="true"
            [xAxisLabel]="xAxisLabel"
            [yAxisLabel]="'Load Volume'">
          </ngx-charts-bar-vertical-stacked>
        </div>

      </div>

    </div>

  </div>



  <figure id="stacked-bar"></figure>




  <button mat-raised-button (click)="toggleDisplayRowLoadsValues()">Display raw values</button>



  <div *ngIf="displayRawLoadsValues">

    <h4>Raw Values - Loads</h4>

    <!-- Table with raw data -->
    <table mat-table [dataSource]="tableLoadsData" class="mat-elevation-z8">

      <!-- Date Column -->
      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef> Date</th>
        <td mat-cell *matCellDef="let element"> {{element.date}} </td>
      </ng-container>

      <!-- Age Group Columns -->
      <ng-container *ngFor="let column of displayedLoadsColumns" [matColumnDef]="column">
        <th mat-header-cell *matHeaderCellDef> {{column}} </th>
        <td mat-cell *matCellDef="let element"> {{element[column]}} </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedLoadsColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedLoadsColumns;"></tr>
    </table>
  </div>




</mat-card>


<div>

</div>


